
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';

export default defineComponent({
  setup() {
    const root = ref<InstanceType<typeof HTMLElement>>();

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    const checkOrientation = () => {
      if (root.value) {
        const isPortrait = root.value.offsetWidth < root.value.offsetHeight;

        if (isPortrait) {
          root.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern-portrait.svg')`;
        } else {
          root.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern.svg')`;
        }
      }
    };

    onMounted(() => {
      window.addEventListener('resize', checkOrientation);
      window.addEventListener('load', checkOrientation);
      checkOrientation();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('load', checkOrientation);
    });

    return {
      root,
    };
  },
});
